import { useHistory } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { S3Image } from './S3Image'; 
import { Tooltip} from 'element-react';

export default function ProductGridCard({ product }) {
    let history = useHistory();
    const { t } = useTranslation();

    if (!product || !product.id) {
        return null; 
    }

    const defaultImageKey = "/default-images/swiper-product-default-img.png";
    const productImageKey = product?.photo?.[0]?.key || defaultImageKey;
    
    const redirectToProductPage = () => history.push("/product-detail/" + product.id);

    const cardImageTheme = {
        photoImg: {
            width: '90%',
            height: '120px',
            objectFit: 'cover',
            padding: '10px',
            borderRadius: '22px'
        }
    };

    return (
        <div className="product-card" onClick={redirectToProductPage} style={{ cursor: 'pointer' }}>
            <S3Image 
                imgKey={productImageKey} 
                alt={product.name}
                theme={cardImageTheme} 
            />
            <div className="product-card-info">
                <Tooltip
                    effect="dark" 
                    content={product.name} 
                    placement="bottom" 
                    trigger="click"
                >
                <h4 className="product-card-name">{product.name}</h4></Tooltip>
                <p className="product-card-by">
                    {t('home-page.by-label', 'by:')} 
                    <b style={{color: '#F76566 '}}> {product.company_name || 'N/A'}</b>
                </p>
                <p className="product-card-price">
                    {`$ ${product.min_price || '0.00'} - $ ${product.max_price || '0.00'} USD`}
                </p>
            </div>
        </div>
    );
}